import React from 'react'
import css from './style.css'
import { selectTextOnFocus } from '../../utils'

const Input = props => {
  const hasError = props.touched && props.error

  const classNames = [
    css.input,
    props.right ? css.right : '',
    props.xs ? css.xs : '',
    props.sm ? css.sm : '',
    props.pad ? css.pad : '',
    hasError ? css.error : '',
    props.disabled ? css.disabled : ''
  ]

  const wrapperClasses = [
    props.inline ? css.inline : '',
    props.flex ? css.flex : '',
    props.right ? css.right : ''
  ]

  const commonProps = {
    disabled: props.disabled,
    className: classNames.join(' '),
    value: props.value,
    placeholder: props.placeholder,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    id: props.inputId
  }

  const numProps = {
    min: props.min,
    max: props.max,
    step: props.step
  }

  const input = (props) => {
    switch (props.type) {
      case 'textarea':
        return <textarea id={props.inputId} rows={props.rows || 3} {...commonProps} />
      case 'number':
        return <input id={props.inputId} type='number' {...commonProps} {...numProps} onFocus={props.onFocus ? props.onFocus : selectTextOnFocus} />
      default:
        return <input id={props.inputId} type={props.type || 'text'} {...commonProps} />
    }
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      {props.prefix && <span className={css.prefix}>{props.prefix}</span>}
      {input(props)}
      {props.suffix && <span className={css.suffix}>{props.suffix}</span>}
      {hasError && <div className={css.error}>{props.error}</div>}
    </div>
  )
}

export default Input



// WEBPACK FOOTER //
// ./src/components/input/index.js